import * as React from "react";
import { MainContext } from "../main-page/main-page.mjs";
const MainContent = (props) => {
  const { hasMainPageComponent } = React.useContext(MainContext);
  const { children, className } = props;
  const BEM = () => {
    const classArray = ["main__content"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  if (hasMainPageComponent) {
    return /* @__PURE__ */ React.createElement("div", { className: BEM() }, children);
  }
  return /* @__PURE__ */ React.createElement("main", { className: BEM(), id: "main-content", tabIndex: -1 }, children);
};
export {
  MainContent
};
